import { Center, Link, Text } from '@chakra-ui/react'

export function NotFound() {
  return (
    <Center
      flexDir={'column'}
      height="100vh">
      <Text
        textStyle="h2"
        as="p"
        mb={8}>
        404 - Page not found
      </Text>
      <Text as="p">
        <Link href="/">Go to home</Link>
      </Text>
    </Center>
  )
}
